import { Box, Button, Grid, Typography } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { Add } from "@mui/icons-material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "shared/store/store";
import { Layout } from "shared/utils/ui/Layout";
import { useWidth } from "shared/hooks/HookDetailedConsultation/useWidth";
import { TableComponent } from "shared/components/Table.component";
import styles from "./styles/deductions.module.scss";
import { useDeductions } from "./hooks/useDeductions";
import { IFieldForm } from "pages/read-documents/model/IFieldForm";

export const Deductions = () => {
  const dispatch = useDispatch<Dispatch>();
  const { width } = useWidth();

  const {
    handleChange,
    handleSubmit,
    columns,
    valuesResultsPages,
    showForm,
    dataFields,
    getValue,
    toogleShowForm,
    createDeduction,
    clearFilters,
  } = useDeductions();

  useEffect(() => {
    dispatch.menuDrawer.changeSelectedIndex(33);
  }, [dispatch.menuDrawer]);

  return (
    <Layout>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        marginTop={".3rem"}
      >
        <Typography className="titleMainLayout">
          Gestión de Deducciones
        </Typography>
        <Box display={"flex"} gap={1}>
          <Button
            className={styles.buttonsActions}
            onClick={() => createDeduction()}
            endIcon={<Add />}
            variant="contained"
            data-testid="btn-create-deduction"
          >
            Crear deducción
          </Button>
          <Button
            className={styles.buttonsActions}
            onClick={toogleShowForm}
            endIcon={showForm ? <FilterAltOffIcon /> : <FilterAltIcon />}
            variant="contained"
            data-testid="btn-filters-deductions"
          >
            Filtrar
          </Button>
        </Box>
      </Box>

      {showForm && (
        <form
          className={`${styles.formReadDocuments} form-documents`}
          noValidate
          onSubmit={handleSubmit}
          data-testid="form-deductions-filters"
        >
          <Grid
            container
            direction={"row"}
            className={styles.containerReadDocuments}
          >
            {dataFields.map((field: IFieldForm, i: number) => (
              <Grid
                item
                xs={12}
                md={6}
                lg={4}
                className={styles.containerGridItem}
                key={i}
              >
                <label htmlFor={field.id}>{field.label}</label>
                <input
                  type="text"
                  name={field.name}
                  placeholder={field.placeholder}
                  id={field.id}
                  data-testid={field.testId}
                  value={getValue(field.name)}
                  onChange={handleChange}
                />
              </Grid>
            ))}

            <Grid container direction={"row"} justifyContent={"center"}>
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                className={styles.buttonSubmit}
                data-testid="btn-submit-deductions"
              >
                Consultar
              </Button>
              <Button
                variant="contained"
                color="secondary"
                className={styles.buttonSubmit}
                data-testid="btn-clear-deductions"
                onClick={clearFilters}
              >
                Limpiar
              </Button>
            </Grid>
          </Grid>
        </form>
      )}

      <Box paddingTop={".5rem"} height={showForm ? "72%" : "89%"}>
        <TableComponent
          columns={columns}
          title=""
          valuesResultsPages={valuesResultsPages}
          classTotalElemnt={width < 500 ? "" : "classTotalElemnt"}
          showBtnCollapse={false}
          hiddenHeaderSearch={true}
          isSearch={false}
        />
      </Box>
    </Layout>
  );
};
